import platform from '@/shared/utils/platform';

export default class URLUtils {
  static getHashString(url: string = window.location.href): string {
    return (/[^#]+#([^?]*)/.exec(url) || [])[1] || '';
  }

  static getQueryString(url: string = window.location.href): string {
    const newUrl = url.split('?');
    if (newUrl.length <= 2) {
      return (/[^?]+\?([^#]*)/.exec(url) || [])[1] || '';
    }
    // 多个？场景
    let newQueryUrl = '';
    newUrl.forEach((e, index) => {
      if (index === 0) {
        newQueryUrl = '';
      } else {
        newQueryUrl = newQueryUrl + (newQueryUrl ? '&' : '') + e.split('#')[0];
      }
    });
    // TODO:待处理 字段一致的情况，做去重
    return newQueryUrl;
  }

  static getBase(url: string = window.location.href): string {
    return url
      .split(`?${URLUtils.getQueryString(url)}`)
      .join('')
      .split(`#${URLUtils.getHashString(url)}`)
      .join('');
  }

  static getQueryMap(url: string = window.location.href): Dictionary {
    return URLUtils.stringToMap(URLUtils.getQueryString(url));
  }

  static getQueryMapAll(url: string = window.location.href): Dictionary {
    return URLUtils.stringToMapAll(URLUtils.getQueryString(url));
  }

  static getHashMap(url: string = window.location.href): Dictionary {
    return URLUtils.stringToMap(URLUtils.getHashString(url));
  }

  static stringToMap(query: string): Dictionary {
    const map: Dictionary = {};

    if (query) {
      const part = query.split('&');

      for (let i = 0, len = part.length; i < len; i += 1) {
        const result = part[i].split('=');
        const key = result[0];
        const value = result[1];

        // 将"c="认为key为c，value为null，将"e"认为key为e，value为true
        // tslint:disable-next-line
        map[key] = value || (typeof value === 'string' ? null : true);
      }
    }

    return map;
  }

  // 新写方法替代当前获取map的方法
  static stringToMapAll(query: string): Dictionary {
    const map: Dictionary = {};

    if (query) {
      const part = query.split('&');

      for (let i = 0, len = part.length; i < len; i += 1) {
        const result = part[i].split('=');
        const key = result[0];
        const value = result[1];
        // 兼容链接上有相同key值的情况
        if (map[key]) {
          if (Array.isArray(map[key])) {
            (map[key] as string[]).push(value);
          } else {
            map[key] = [map[key], value];
          }
        } else {
          map[key] = value || (typeof value === 'string' ? null : true);
        }
      }
    }

    return map;
  }

  /** 修改url上的参数 */
  static changeURLArg = (url: string, arg: string, val: string): string => {
    const re = new RegExp(`(${arg}=)([^&]*)`, 'gi');
    let newUrl = url.replace(re, `${arg}=${val}`);
    // 若原本就没有这个参数，则添加
    if (newUrl === url && newUrl.indexOf(`${arg}=${val}`) < 0) {
      const code = url.indexOf('?') > -1 ? '&' : '?';
      newUrl = `${url}${code}${arg}=${val}`;
    }
    return newUrl;
  };

  /** 判断是否为内部链接 */
  static isInternalLink = (link: string): boolean => {
    const { host } = new URL(link);
    return !!host && ['m.hellobike.com', 'm.hellobike.cn'].includes(host);
  };

  /** 拼接链接参数 */
  static formatUrl = (link: string, options: Dictionary): string => {
    if (Object.prototype.toString.call(options) === '[object Object]') {
      let formatUrlStr = link;
      const linkHasParams = link.indexOf('?') > -1;
      let hasQueryTmp = false;
      Object.keys(options).forEach((key) => {
        const hasQuery = hasQueryTmp || linkHasParams;
        if (options[key] !== null && options[key] !== undefined) {
          formatUrlStr += `${!hasQuery ? '?' : '&'}${key}=${String(options[key])}`;
          hasQueryTmp = true;
        }
      });
      return formatUrlStr;
    }
    return link;
  };

  /** 判断是否为pdf链接 */
  static isPDFLink = (link: string): boolean => /\.pdf/g.test(link);

  /**
   * 判断是否 需要使用虚拟iframe的方式打开合同链接
   * 若为 安卓App环境 且 链接不是PDF预览模式 且 是PDF类型的链接，则使用虚拟iframe模式打开，跳转至默认浏览器下载合同文件
   * 此操作是为了解决：安卓App环境下，外跳至手机浏览器打开合同链接，下载合同文件后返回至App出现白屏的问题
  */
  static needOpenContractWithVirtualIframe = (link: string): boolean => (
    platform.isHelloAndroidApp && !link.includes('pdf_url=') && URLUtils.isPDFLink(link)
  );
}
